import Commons from '../../../../Services/Common/Common';

export const M_TBM_CUSTOM_02_Schema = {
  mapper: {
    /** 동영상/교육자료 조회 SP_TBM_CUSTOM_R1 */
    search1: {
      UserId: (context) => context.userInfo?.userid,
      TbmYn: (context) =>
        Commons.EncryptAES(context.userInfo?.tbmYn) || '',
    },
  },
};
